import { render, staticRenderFns } from "./OutlineFieldsModal.vue?vue&type=template&id=a2c8be88"
import script from "./OutlineFieldsModal.vue?vue&type=script&lang=js"
export * from "./OutlineFieldsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2c8be88')) {
      api.createRecord('a2c8be88', component.options)
    } else {
      api.reload('a2c8be88', component.options)
    }
    module.hot.accept("./OutlineFieldsModal.vue?vue&type=template&id=a2c8be88", function () {
      api.rerender('a2c8be88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/OutlineFieldsModal.vue"
export default component.exports